export default __webpack_public_path__ + "static/media/simulate-volcano-icon.dd98c2f2.png";